import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { ArrayImage, responsive } from "../../Data";
import BoxSlider from "./BoxSlider";

function SliderImage() {

    const ArrayHandler = ArrayImage.map((item) => (
        <BoxSlider key={item.id} image={item.image} id={item.id} />
    ))

    return (
        <div className="flex items-center justify-center">
            <div className="2xl:w-9/12
                            xl:w-10/12
                            lg:w-11/12
                            md:w-11/12
                            w-11/12
                            p-10">
                <Carousel
                    responsive={responsive}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    swipeable={true}
                    draggable={true}
                    showDots={true}
                    infinite={true}
                    partialVisible={false}
                    dotListClass="custom-dot-list-style"
                >
                    {ArrayHandler}
                </Carousel>
            </div>
        </div>
    )
}
export default SliderImage;